import React from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;

import './loading.scss';

export const LoadingDepositCallout = ({ depositCalloutReduced }) => {
  return (
    <div className="loading-rental-deposit">
      {depositCalloutReduced ? (
        <div className="loading-container">
          <div className="loading-bar sm" />
        </div>
      ) : (
        <div className="loading-container">
          <div className="loading-bar lg" />
          <div className="loading-bar sm" />
          <div className="loading-bar md" />
        </div>
      )}
    </div>
  );
};

LoadingDepositCallout.displayName = 'LoadingDepositCallout';

LoadingDepositCallout.propTypes = {
  depositCalloutReduced: bool.isRequired
};